import React, { Component } from 'react';
import { connect, } from 'react-redux';
import { Accordion, Container, } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import { withRouter } from './withRouter';
import PageSEO from 'components/Utlility/PageSEO';
import { SEO_CONFIG } from 'constants/SeoConfig';
import styles from "./HelpStyles.module.scss";

import smartTv1 from "images/template/help/smart-tv-1.png";
import laptop1 from "images/template/help/laptop-1.png";
import laptop2 from "images/template/help/laptop-2.png";
import laptop3 from "images/template/help/laptop-3.png";
import laptop4 from "images/template/help/laptop-4.png";
import laptop5 from "images/template/help/laptop-5.png";
import usbC from "images/template/help/usb-c.png";
import cable from "images/template/help/cable.png";
import tv from "images/template/help/tv.png";
import laptop from "images/template/help/laptop.png";
import tablet from "images/template/help/tablet.png";

import join1 from "images/template/help/join-1.png";
import join2 from "images/template/help/join-2.png";
import join3 from "images/template/help/join-3.png";
import join4 from "images/template/help/join-4.png";

import wizard from "images/template/help/wizard.png";
import wizardDone from "images/template/help/wizard-done.png";
import { PROMO_VIDEO_EMBED_URL } from 'constants/SiteContent';

const FIRE_TV_APP_LINK = "https://www.amazon.co.uk/Game-City-Game-City/dp/B0FCYQ3QY7/ref=sr_1_6?crid=1HYZ8KROZPE3Q&dib=eyJ2IjoiMSJ9.8FmPt9aRPWTU9EIjS4v9rBc1OzkR5g7FwwI6Bts_C4nD1Hos0s_FKTAEzgkEW5MWoFy-Z7AN9cDeW70SMLQ_JiDh_WU6x3PrH2CxLSmUbHPBgWA-UszU3foPJtC0pK2aseieTBMCVzwS2Ez2UeKVh-cjY5p_0E_fqYRG4qAfYscIMoOKn-1jKWxS-RpyIw9lgpr8JUMQaSZyq_COX2MO3SKsoyShTzZONoktuJoNTJkVJ2fcS4g_iGAU5y-Qy8g45K9Cah0IEH2EkelWFkIHmt6SKaU8FDTL3FTD90uElsk.DYEAaB96KVfdhfMuXvjklBo42TKSgftMh4AT_oE44mU&dib_tag=se&keywords=Game+City&qid=1756198594&sprefix=game+city%2Caps%2C104&sr=8-6"
const ROKU_APP_LINK = "https://channelstore.roku.com/en-gb/details/f40f6c4e12bfb9b619aa4530404178ea:bf00789f9ba54a68d7fc648d46ddbfc5/game-city-party-games-on-tv"

const FAQ_ITEMS = [
    { q: "Do I need to sign in or register to join a game?", a: "Nope! Only the host needs to sign in with their account - all you need to do is 'Join a Game' with the room code your host gives you." },
    { q: "I've been disconnected from the game!", a: "No worries - just go to the join a game page, and re-enter the room code to reconnect!" },
    { q: "We're all ready, but the game won't start!", a: "Do you have enough players for that game? Check you have the required amount of players connected before you try start a game!" },
    { q: "I can't sign in!", a: "Have you registered your account yet? Check for typos and make sure you're using the right email address." },
    { q: "Can I host this on my Smart TV?", a: "Game.City works best when hosted from a laptop, desktop computer or Fire TV/Roku stick, as those devices tend to have a faster processing speed. If you want to get this on your Big Screen - we recommend going old school and hooking your screen up via an HDMI cable." },
    { q: "Help! I've lost my Steam key(s), how do I recover them?", a: "If you bought a Steam key on bigpotato.tv, and need to recover it, get in touch with the email address you used when you purchased it!" },
    { q: "My activation code says redeemed - how do I find it?", a: "You should have received an email with your activation code. If you registered after you bought it, it's likely already on your account. Simply login, go to 'Start a Game' and your games should appear." },
    { q: "My discount code won't work?", a: "Check if you have a discount code or an activation code. Discounts work only on the checkout page and activation codes work only on the Redeem Code page!" },
    { q: "How do I find game.city on Fire TV?", a: "Search for 'game city'. We should appear. Download the app and login." },
    { q: "How do I find game.city on Roku?", a: "Search for 'game city'. We should appear. Download the app and login. Please note that Playing with Fire and Poker are not currently available on the Roku app." },
];

class Help extends Component {
    static displayName = Help.name;

    constructor(props) {
        super(props);

        this.state = {
        };
    }

    componentDidMount() {

    }

    render() {
        return (
            <article>
                <PageSEO {...SEO_CONFIG['/help']} />
                <Helmet>
                    <script type="application/ld+json">{JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "FAQPage",
                        "mainEntity": FAQ_ITEMS.map(item => ({
                            "@type": "Question",
                            "name": item.q,
                            "acceptedAnswer": { "@type": "Answer", "text": item.a }
                        }))
                    })}</script>
                </Helmet>
                <div className={styles.cloudBG} />
                <section className={`${styles.setupWizardSection} ${styles.band}`}>
                    <Container>

                        {/*<div className={`${styles.youWillNeed} ${styles.restrictWidth}`}>*/}
                        {/*    <p className={`${styles.callout}`}>Playing a party game on your TV might sound like magic, but don't worry - it's actually quite simple with Game.City</p>*/}
                        {/*    <h2>You will need:</h2>*/}

                        {/*    <div className={styles.items}>*/}
                        {/*        <span className={styles.imageCol}><img src={tv}></img><p>A Smart TV, Fire TV, or Roku Stick</p></span>*/}
                        {/*    </div>*/}
                        {/*    <div className={styles.items}>*/}
                        {/*        <p style={{ fontSize: '25px' }}>and/or</p>*/}
                        {/*    </div><div className={styles.items}>*/}
                        {/*        <span className={styles.imageCol}><img src={laptop}></img><p>A Laptop</p></span>*/}
                        {/*        <p style={{ fontSize: '25px' }}>+</p>*/}
                        {/*        <span className={styles.imageCol}><img src={cable}></img><p>An HDMI Cable</p></span>*/}
                        {/*        <p style={{ fontSize: '25px', margin: '0px 10px'}}>or</p>*/}
                        {/*        <span className={styles.imageCol}><img src={tablet}></img><p>A Tablet/iPad with Screen mirroring </p></span>*/}
                        {/*    </div>*/}

                        {/*</div>*/}

                        <div className={`${styles.gameOnTv} ${styles.guide} ${styles.restrictWidth}`}>

                            <h2>1. Getting your game on the big screen</h2>

                            <hr />

                            <h3><a href={FIRE_TV_APP_LINK} rel="noreferrer" target="_blank">Fire TV</a> or <a href={ROKU_APP_LINK} rel="noreferrer" target="_blank">ROKU</a></h3>

                            <strong className={styles.subHeading}>On your device, go to Search, type Game.City, select the app, choose Get or Open, then follow the on-screen instructions to play using your phone at game.city.</strong>
                            <hr />

                            {/*<h3>Fire TV</h3>*/}

                            {/*<strong className={styles.subHeading}>On your <a href={FIRE_TV_APP_LINK} rel="noreferrer" target="_blank">Fire TV</a>, go to Search, type Game.City, select the app, choose Get or Open, then follow the on-screen instructions to play using your phone at game.city.</strong>*/}
                            {/*<hr />*/}

                            {/*<h3>Roku Stick</h3>*/}

                            {/*<strong className={styles.subHeading}>Simply plug in a <a href={ROKU_APP_LINK} rel="noreferrer" target="_blank">Roku</a> stick, and search for “game city”. We should appear. Download the app and login.</strong>*/}
                            {/*<hr />*/}

                            <h3>Using a laptop and HDMI cable</h3>

                            <strong className={styles.subHeading}>For this step, you'll need to manually plug your laptop into the back of your TV, Here's what to do:</strong>

                            <ol>
                                <li>
                                    <span className={styles.imageRow}>
                                        <p>Plug one end of the HDMI cable into your laptop.</p>
                                        {/*<img src={laptop1}></img>*/}
                                    </span>
                                </li>
                                <li>
                                    <span className={styles.imageRow}>
                                        <p>Plug the other end of the cable into the HDMI socket in the back (or side) of the TV</p>
                                        {/*<img src={laptop2}></img>*/}
                                    </span>
                                </li>
                                <li>
                                    <span className={styles.imageRow}>
                                        <p>Switch on your TV, Your laptop should now be visible on one of the HDMI channels.</p>
                                        {/*<img src={laptop3}></img>*/}
                                    </span>
                                </li>
                                <li>
                                    <span className={styles.imageRow}>
                                        <p>On your laptop, go to <a href="https://game.city">game.city</a> and select <strong style={{ textTransform: 'uppercase' }}>start game</strong></p>
                                        {/*<img src={laptop4}></img>*/}
                                    </span>
                                </li>
                                <li>
                                    <span className={styles.imageRow}>
                                        <p>Type in your registered email and password to start the game.</p>
                                        {/*<img src={laptop5}></img>*/}
                                    </span>
                                </li>
                            </ol>

                            <hr />


                            <h3>Tablet/iPad screen mirroring  </h3>

                            <strong className={styles.subHeading}>If you have the ability to screen mirror from a tablet or iPad, you can simply open your browser, navigate to game.city and choose to mirror your screen directly to the TV. </strong>

                            <hr />

                            <h3>On a Smart TV: </h3>

                            <strong className={styles.subHeading}>Locate the browser application, enter game.city and login.</strong>

                            <hr />


                            <h2>2. Getting Everyone To Join The Game</h2>

                            <strong className={styles.subHeading}>Now that you're up on the big screen, it's time to get the players involved!</strong>

                            <ol>
                                <li>
                                    <span className={styles.imageRow}>
                                        <p>To join, scan the QR code with your smartphone or visit <a href="https://game.city">game.city</a> and select <strong style={{ textTransform: 'uppercase' }}>join a game</strong> and enter the Room ID found on the left of the host.</p>
                                        {/*                                        <p>To join, go to <a href="https://game.city">game.city</a> on your smartphone and select <strong style={{textTransform: 'uppercase'}}>join a game</strong></p>*/}
                                        {/*<img src={join1}></img>*/}
                                    </span>
                                </li>
                                {/*<li>*/}
                                {/*    <span className={styles.imageRow}>*/}
                                {/*        <p>Type in the Room ID, found on the left side of the screen.</p>*/}
                                {/*        */}{/*<img src={join2}></img>*/}
                                {/*    </span>*/}
                                {/*</li>*/}
                                <li>
                                    <span className={styles.imageRow}>
                                        <p>Make up a nickname, choose an avatar, and wait for the other players to join. </p>
                                        {/*<img src={join3}></img>*/}
                                    </span>
                                </li>
                                <li>
                                    <span className={styles.imageRow}>
                                        <p>The VIP player can pick a game to get started, everyone else can vote on what to play, then do your best to win. Have fun!</p>
                                        {/*<img src={join4}></img>*/}
                                    </span>
                                </li>
                            </ol>


                            <hr />

                            <h2>You've Done It!</h2>

                            <div className={styles.allDone}>
                                <div>
                                    <strong className={styles.subHeading}>You're officially ready to play on the big screen!</strong>
                                    <p>Good luck, have fun, and don't be too disappointed if you don't win the trophy, there's always next round.</p>
                                    <p>If you run into any problems, please <a href="mailto:info@thegamescollective.com">Get in Touch</a></p>
                                </div>
                                {/*<img src={wizardDone}></img>*/}
                            </div>
                            <iframe
                                style={{
                                    position: "relative",
                                    width: "100%",
                                    height: "100%",
                                    aspectRatio: "16/9",
                                }}
                                src={PROMO_VIDEO_EMBED_URL}
                                title="YouTube video player"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            />
                            <hr />

                            <h2>Top Tips</h2>

                            <strong className={styles.subHeading}>Want to make sure your gaming experience on the TV is smooth and fun? </strong>


                            <div className={styles.notice}>
                                <p>The smoothest experiences are through a direct Laptop + HDMI connection, or a <a href="https://www.amazon.co.uk/Game-City-Game-City/dp/B0FCYQ3QY7/ref=sr_1_6?crid=1HYZ8KROZPE3Q&dib=eyJ2IjoiMSJ9.8FmPt9aRPWTU9EIjS4v9rBc1OzkR5g7FwwI6Bts_C4nD1Hos0s_FKTAEzgkEW5MWoFy-Z7AN9cDeW70SMLQ_JiDh_WU6x3PrH2CxLSmUbHPBgWA-UszU3foPJtC0pK2aseieTBMCVzwS2Ez2UeKVh-cjY5p_0E_fqYRG4qAfYscIMoOKn-1jKWxS-RpyIw9lgpr8JUMQaSZyq_COX2MO3SKsoyShTzZONoktuJoNTJkVJ2fcS4g_iGAU5y-Qy8g45K9Cah0IEH2EkelWFkIHmt6SKaU8FDTL3FTD90uElsk.DYEAaB96KVfdhfMuXvjklBo42TKSgftMh4AT_oE44mU&dib_tag=se&keywords=Game+City&qid=1756198594&sprefix=game+city%2Caps%2C104&sr=8-6" target="_blank">Fire TV</a>/<a href="https://channelstore.roku.com/en-gb/details/f40f6c4e12bfb9b619aa4530404178ea:bf00789f9ba54a68d7fc648d46ddbfc5/game-city-party-games-on-tv" target="_blank">Roku</a> stick. </p>
                            </div>



                            <div className={styles.notice}>
                                <p>If you've already set up your TV with Google Chromecast, or Apple AirPlay, you can use this to mirror your laptop display
                                    (instead of using an HDMI cable)</p>
                            </div>


                            <div className={styles.notice}>
                                <p>You can also play the games through the Web Browser on your Smart TV. </p>
                            </div>

                            <div className={styles.notice}>
                                <p>Close any unused tabs in your browser to free up some space for your game. If things are feeling a little slow, clearing your browser's cache and history can work wonders. It's like giving your TV a quick refresh! You can also try restarting the browser or your TV for a clean start.  </p>
                            </div>

                            <div className={styles.notice}>
                                <p>If your game is disconnecting unexpectedly, please check the quality of your connection and ensure that your controller devices stay on the game.city website, rather than changing applications (and checking your Instagram feed 😂).  </p>
                            </div>



                            {/*<div className={`${styles.notice} ${styles.imageNotice}`}>*/}
                            {/*    <p>You can also connect your laptop to your TV via a HDMI cable. Some smaller laptops (especially Apple Macs) may not have an HDMI socket. if this happens, you'll need to purchase a USB-C to HDMI adapter.</p>*/}
                            {/*    */}{/*<img src={usbC}></img>*/}
                            {/*</div>*/}

                            {/*<div className={`${styles.notice} ${styles.imageNotice}`}>*/}
                            {/*    <p>You can also play the games through the Web Browser on your Smart TV! <br /> Close any unused tabs in your browser to free up some space for your game. If things are feeling a little slow, clearing your browser's cache and history can work wonders. It's like giving your TV a quick refresh! You can also try restarting the browser or your TV for a clean start.</p>*/}
                            {/*    */}{/*<img src={smartTv1}></img>*/}
                            {/*</div>*/}


                        </div>
                    </Container>
                </section>

                <div className={styles.cityScape} />

                <section className={`${styles.faqSection} ${styles.band}`} id="faqSection" style={{ width: "100%", paddingTop: "40px", paddingBottom: "40px" }}>
                    <div className="container">
                        <div className="row" style={{ marginTop: "20px" }} id="faqrowid">
                            <h1 className='text-center'>{SEO_CONFIG['/help'].h1}</h1>
                        </div>
                        <Accordion className={`${styles.restrictWidth} ${styles.faqs}`} style={{ marginBottom: "10px" }} id="faqAccordion">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header><h3>DO I NEED TO SIGN IN OR REGISTER TO JOIN A GAME?</h3></Accordion.Header>
                                <Accordion.Body>
                                    <p>Nope! Only the host needs to sign in with their account - all you need to do is 'Join a Game' with the room code your hosts gives you.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header><h3>I'VE BEEN DISCONNECTED FROM THE GAME!</h3></Accordion.Header>
                                <Accordion.Body>
                                    <p>No worries - just go to the join a game page, and re-enter the room code to reconnect!</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header><h3>WE'RE ALL READY, BUT THE GAME WON'T START!</h3></Accordion.Header>
                                <Accordion.Body>
                                    <p>Do you have enough players for that game? Check you have the required amount of players connected before you try start a game! If everything looks right, <a href="mailto:info@thegamescollective.com">Get in Touch</a>!</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="3">
                                <Accordion.Header><h3>I CAN'T SIGN IN!</h3></Accordion.Header>
                                <Accordion.Body>
                                    <p>Have you registered your account yet? </p>
                                    <p>Check for typos and make sure you're using the right email address.</p>
                                    <p>Having trouble? <a href="mailto:info@thegamescollective.com">Get in Touch</a></p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="4">
                                <Accordion.Header><h3>CAN I HOST THIS ON MY SMART TV?</h3></Accordion.Header>
                                <Accordion.Body>
                                    <p>Game.City works best when hosted from a laptop,desktop computer or <a href="https://www.amazon.co.uk/Game-City-Game-City/dp/B0FCYQ3QY7/ref=sr_1_6?crid=1HYZ8KROZPE3Q&dib=eyJ2IjoiMSJ9.8FmPt9aRPWTU9EIjS4v9rBc1OzkR5g7FwwI6Bts_C4nD1Hos0s_FKTAEzgkEW5MWoFy-Z7AN9cDeW70SMLQ_JiDh_WU6x3PrH2CxLSmUbHPBgWA-UszU3foPJtC0pK2aseieTBMCVzwS2Ez2UeKVh-cjY5p_0E_fqYRG4qAfYscIMoOKn-1jKWxS-RpyIw9lgpr8JUMQaSZyq_COX2MO3SKsoyShTzZONoktuJoNTJkVJ2fcS4g_iGAU5y-Qy8g45K9Cah0IEH2EkelWFkIHmt6SKaU8FDTL3FTD90uElsk.DYEAaB96KVfdhfMuXvjklBo42TKSgftMh4AT_oE44mU&dib_tag=se&keywords=Game+City&qid=1756198594&sprefix=game+city%2Caps%2C104&sr=8-6" target="_blank">Fire TV</a>/<a href="https://channelstore.roku.com/en-gb/details/f40f6c4e12bfb9b619aa4530404178ea:bf00789f9ba54a68d7fc648d46ddbfc5/game-city-party-games-on-tv" target="_blank">Roku</a> stick, as those devices tend to have a faster processing speed. If you want to get this on your Big Screen - we recommend going old school and hooking your screen up via an HDMI cable.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="5">
                                <Accordion.Header><h3>HELP! I'VE LOST MY STEAM KEY(S), HOW DO I RECOVER THEM?</h3></Accordion.Header>
                                <Accordion.Body>
                                    <p>If you bought a Steam key on bigpotato.tv, and need to recover it, <a href="mailto:info@thegamescollective.com">Get in Touch</a> with the email address you used when you purchased it!</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="6">
                                <Accordion.Header><h3>MY ACTIVATION CODE SAYS REDEEMED - HOW DO I FIND IT?</h3></Accordion.Header>
                                <Accordion.Body>
                                    <p>You should have recieved an email with your activation code, if you registered after you bought it, it's likely already on your account, Great! Simply login, go to 'Start a Game' and your games should appear. If not, then check the code is being entered correctly. If it's still not working then <a href="mailto:info@thegamescollective.com">Get in Touch</a>.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="7">
                                <Accordion.Header><h3>MY DISCOUNT CODE WON'T WORK?</h3></Accordion.Header>
                                <Accordion.Body>
                                    <p>Check if you have a discount code or a activation code, discounts work only on the check out page and activation codes work only on the <a target="_blank" href="https://game.city/redeem-code">Redeem Code</a> page!</p>
                                </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="8">
                                <Accordion.Header><h3>How do I find game.city on Fire TV? </h3></Accordion.Header>
                                <Accordion.Body>
                                    <p>search for “game city”. We should appear. <a href="https://www.amazon.co.uk/Game-City-Game-City/dp/B0FCYQ3QY7/ref=sr_1_6?crid=1HYZ8KROZPE3Q&dib=eyJ2IjoiMSJ9.8FmPt9aRPWTU9EIjS4v9rBc1OzkR5g7FwwI6Bts_C4nD1Hos0s_FKTAEzgkEW5MWoFy-Z7AN9cDeW70SMLQ_JiDh_WU6x3PrH2CxLSmUbHPBgWA-UszU3foPJtC0pK2aseieTBMCVzwS2Ez2UeKVh-cjY5p_0E_fqYRG4qAfYscIMoOKn-1jKWxS-RpyIw9lgpr8JUMQaSZyq_COX2MO3SKsoyShTzZONoktuJoNTJkVJ2fcS4g_iGAU5y-Qy8g45K9Cah0IEH2EkelWFkIHmt6SKaU8FDTL3FTD90uElsk.DYEAaB96KVfdhfMuXvjklBo42TKSgftMh4AT_oE44mU&dib_tag=se&keywords=Game+City&qid=1756198594&sprefix=game+city%2Caps%2C104&sr=8-6" target="_blank">Download the app</a> and login. </p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="9">
                                <Accordion.Header><h3>How do I find game.city on Roku? </h3></Accordion.Header>
                                <Accordion.Body>
                                    <p>Search for “game city”. We should appear. Download the app and login.</p>
                                    <p>Please note that Playing with Fire and Poker are not currently available on the <a href="https://channelstore.roku.com/en-gb/details/f40f6c4e12bfb9b619aa4530404178ea:bf00789f9ba54a68d7fc648d46ddbfc5/game-city-party-games-on-tv" target="_blank">Roku</a> app.</p>
                                    <br />
                                    <p><strong>Some older or “Lite” Roku models don’t support our channel.</strong> To check your device, go to <em>Settings → System → About</em> — if you’re using an older Roku Express or another low-spec model, it may not be compatible.</p>
                                </Accordion.Body>
                            </Accordion.Item>

                        </Accordion>
                    </div>
                </section>

                <section className={`${styles.band} ${styles.small}`}>
                    <div className={`${styles.intro} ${styles.restrictWidth}`} style={{ justifyContent: 'center' }}>
                        <p>Still having problems?</p>
                        <button className={`${styles.button} ${styles.alternate}`} onClick={() => window.open("mailto:info@thegamescollective.com")}>Get in Touch</button>
                    </div>
                </section>
            </article>
        );
    }
}

export default withRouter(Help);
